// Utils
import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';

// Components
import initMenu from './components/menu';
import initCookies from './components/cookies';
import initSearch from './components/search';
import initColorCards from './components/color-cards';
import initScaleScroll from './components/scale-scroll';

// Flex / bespoke components
import initVideoEmbed from './components/video-embed';
import initHorizSections from './components/horiz-section';
import initImageGalleries from './components/image-gallery';
import initoverlapPanels from './components/overlap-panels';
import initCultureCta from './components/culture-cta';
import initServiceNav from './components/service-nav';
import initAccordions from './components/accordions';

// Init cookie plugin if not home page, which is done in home.js
if (document.body.dataset.page !== 'home') {
    initCookies();
}

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const menuEl = document.querySelector('.js-menu');

if (menuEl) {
    initMenu(menuEl);
}

const searchEl = document.querySelector('.js-search');

if (searchEl) {
    initSearch(searchEl);
}

const colorCards = document.querySelectorAll('.js-color-card');

if (colorCards && colorCards.length > 0) {
    initColorCards(colorCards);
}

const scaleScrollEls = document.querySelectorAll('.js-scale-scroll');

if (scaleScrollEls && scaleScrollEls.length > 0) {
    initScaleScroll(scaleScrollEls);
}

const videoEmbedEls = document.querySelectorAll('.js-video-embed');

if (videoEmbedEls && videoEmbedEls.length > 0) {
    initVideoEmbed(videoEmbedEls);
}

const horizSections = document.querySelectorAll('.js-horiz-section');

if (horizSections && horizSections.length > 0) {
    initHorizSections(horizSections);
}

const imageGallerySections = document.querySelectorAll('.js-image-gallery');

if (imageGallerySections && imageGallerySections.length > 0) {
    initImageGalleries(imageGallerySections);
}

const overlapPanels = document.querySelectorAll('.js-overlap-panels');

if (overlapPanels && overlapPanels.length > 0) {
    initoverlapPanels(overlapPanels);
}

const serviceNav = document.querySelector('.js-service-nav');

if (serviceNav) {
    initServiceNav(serviceNav);
}

const cultureCta = document.querySelector('.js-culture-cta');

if (cultureCta) {
    initCultureCta(cultureCta);
}

const accordions = document.querySelectorAll('.js-accordions');

if (accordions && accordions.length > 0) {
    initAccordions(accordions);
}
